module.exports = __webpack_public_path__ + "img/lx.ed66de2d.svg";